var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-md-12" },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "col-md-10 text-left" }, [
                _c("h2", [_vm._v("Ocorrências")])
              ]),
              _vm._v(" "),
              _vm.perfil == "distribuidor"
                ? _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { "align-v": "end" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success", size: "sm" },
                          on: { click: _vm.novaOcorrencia }
                        },
                        [
                          _c("i", { staticClass: "fas fa-plus" }),
                          _vm._v(" Nova Ocorrência\n        ")
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            [
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.perfil,
                      expression: "perfil"
                    }
                  ],
                  attrs: { "align-v": "end" }
                },
                [
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Ocorrência")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: { size: "sm", placeholder: "Código" },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.buscar()
                          }
                        },
                        model: {
                          value: _vm.cod_ocorrencia,
                          callback: function($$v) {
                            _vm.cod_ocorrencia = $$v
                          },
                          expression: "cod_ocorrencia"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.perfil !== "distribuidor"
                    ? _c(
                        "b-col",
                        { staticClass: "col-md-2" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Distribuidor")
                          ]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            attrs: {
                              size: "sm",
                              placeholder: "Código ou Nome"
                            },
                            on: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.buscar()
                              }
                            },
                            model: {
                              value: _vm.distribuidor,
                              callback: function($$v) {
                                _vm.distribuidor = $$v
                              },
                              expression: "distribuidor"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Departamento")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { size: "sm", options: _vm.optionRoles },
                        model: {
                          value: _vm.departamento,
                          callback: function($$v) {
                            _vm.departamento = $$v
                          },
                          expression: "departamento"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("label", { attrs: { for: "" } }, [_vm._v("Status")]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: { size: "sm", options: _vm.optionStatus },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.perfil !== "distribuidor"
                    ? _c(
                        "b-col",
                        { staticClass: "col-md-1" },
                        [
                          _c("label", { attrs: { for: "" } }, [_vm._v("UF")]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { size: "sm", options: _vm.optionsUf },
                            model: {
                              value: _vm.uf,
                              callback: function($$v) {
                                _vm.uf = $$v
                              },
                              expression: "uf"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.perfil !== "distribuidor"
                    ? _c(
                        "b-col",
                        { staticClass: "col-md-1" },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Classe")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: { size: "sm", options: _vm.optionsClasse },
                            model: {
                              value: _vm.classe,
                              callback: function($$v) {
                                _vm.classe = $$v
                              },
                              expression: "classe"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.perfil,
                      expression: "perfil"
                    }
                  ],
                  staticClass: "mt-3",
                  attrs: { "align-v": "end" }
                },
                [
                  _vm.perfil !== "distribuidor"
                    ? _c(
                        "b-col",
                        { attrs: { cols: "2" } },
                        [
                          _c("label", { attrs: { for: "" } }, [
                            _vm._v("Analista")
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            attrs: {
                              size: "sm",
                              options: _vm.optionsAnalistas
                            },
                            model: {
                              value: _vm.analista,
                              callback: function($$v) {
                                _vm.analista = $$v
                              },
                              expression: "analista"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { staticClass: "mb-0", attrs: { for: "" } }, [
                        _vm._v("De")
                      ]),
                      _vm._v(" "),
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "de",
                          placeholder: "Nenhuma Data",
                          "calendar-width": "200",
                          "label-no-date-selected": "",
                          "label-next-month": "Próximo Mês",
                          "label-next-year": "Próximo Ano",
                          "label-prev-month": "Mês Anterior",
                          "label-prev-year": "Ano Anterior",
                          "label-current-month": "Mês Atual",
                          "label-help": "",
                          "hide-header": "",
                          "reset-button": "",
                          "reset-button-variant": "danger",
                          "label-reset-button": "Limpar",
                          size: "sm",
                          "date-format-options": {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                          },
                          locale: "pt-BR"
                        },
                        model: {
                          value: _vm.de,
                          callback: function($$v) {
                            _vm.de = $$v
                          },
                          expression: "de"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-2" },
                    [
                      _c("label", { staticClass: "mb-0", attrs: { for: "" } }, [
                        _vm._v("Até")
                      ]),
                      _vm._v(" "),
                      _c("b-form-datepicker", {
                        attrs: {
                          id: "ate",
                          placeholder: "Nenhuma Data",
                          "calendar-width": "200",
                          "label-no-date-selected": "",
                          "label-next-month": "Próximo Mês",
                          "label-next-year": "Próximo Ano",
                          "label-prev-month": "Mês Anterior",
                          "label-prev-year": "Ano Anterior",
                          "label-current-month": "Mês Atual",
                          "label-help": "",
                          "hide-header": "",
                          "reset-button": "",
                          "reset-button-variant": "danger",
                          "label-reset-button": "Limpar",
                          size: "sm",
                          "date-format-options": {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric"
                          },
                          locale: "pt-BR"
                        },
                        model: {
                          value: _vm.ate,
                          callback: function($$v) {
                            _vm.ate = $$v
                          },
                          expression: "ate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            disabled: _vm.loading,
                            variant: "primary",
                            size: "sm"
                          },
                          on: {
                            click: function($event) {
                              return _vm.buscar()
                            }
                          }
                        },
                        [
                          _c("i", { staticClass: "fas fa-search" }),
                          _vm._v(" Buscar\n          ")
                        ]
                      ),
                      _vm._v(" "),
                      _vm.perfil !== "distribuidor"
                        ? _c(
                            "b-button",
                            {
                              staticClass: "ml-3",
                              attrs: {
                                disabled: _vm.loading,
                                variant: "success",
                                size: "sm"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.exportar()
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-file-excel" }),
                              _vm._v(" Exportar\n          ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-3",
                          attrs: {
                            disabled: _vm.loading,
                            variant: "secondary",
                            size: "sm",
                            title: "Limpar Filtros"
                          },
                          on: {
                            click: function($event) {
                              return _vm.limpar()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-broom" })]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    [
                      _vm.ocorrencias.data.length > 0
                        ? _c("b-pagination", {
                            attrs: {
                              align: "fill",
                              size: "sm",
                              "total-rows": _vm.ocorrencias.total,
                              "per-page": _vm.ocorrencias.per_page
                            },
                            on: {
                              input: function($event) {
                                return _vm.loadOcorrencias()
                              }
                            },
                            model: {
                              value: _vm.ocorrencias.current_page,
                              callback: function($$v) {
                                _vm.$set(_vm.ocorrencias, "current_page", $$v)
                              },
                              expression: "ocorrencias.current_page"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "col-md-1 text-right" },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "sm",
                          title: "Por Página",
                          options: _vm.optionsPerPage
                        },
                        model: {
                          value: _vm.perPage,
                          callback: function($$v) {
                            _vm.perPage = $$v
                          },
                          expression: "perPage"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { staticClass: "col-md-1 text-right" }, [
                    _vm.total > 0
                      ? _c("div", [_vm._v("Total: " + _vm._s(_vm.total))])
                      : _vm._e()
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      fields:
                        _vm.perfil !== "distribuidor"
                          ? _vm.fieldsAdm
                          : _vm.fields,
                      items: _vm.ocorrenciasGet,
                      "show-empty": "",
                      busy: _vm.loading,
                      "empty-text": "Nenhuma Ocorrência Encontrada..."
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "table-busy",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "text-center my-2" },
                                [
                                  _c("b-spinner", {
                                    staticClass: "align-middle"
                                  }),
                                  _vm._v(" "),
                                  _c("strong", [
                                    _vm._v(" Buscando Ocorrências ...")
                                  ])
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "cell(status)",
                          fn: function(row) {
                            return [
                              _c(
                                "b-badge",
                                { attrs: { variant: row.item.variant } },
                                [_vm._v(_vm._s(row.item.status))]
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(updated_at)",
                          fn: function(row) {
                            return [
                              _vm.perfil !== "distribuidor"
                                ? _c(
                                    "b-badge",
                                    {
                                      class: { blink: row.item.isBlinking },
                                      attrs: { variant: row.item.variantDate }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.formatarData(
                                              row.item.updated_at
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.formatarData(row.item.updated_at)
                                        ) +
                                        "\n            "
                                    )
                                  ])
                            ]
                          }
                        },
                        {
                          key: "cell(departamento_anterior)",
                          fn: function(row) {
                            return [
                              _c("b-badge", { attrs: { variant: "light" } }, [
                                _vm._v(
                                  _vm._s(
                                    row.item.historico &&
                                      row.item.historico.length > 0
                                      ? _vm.getDepartamentoAnterior(
                                          row.item.historico
                                        )
                                      : ""
                                  )
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "cell(departamento_atual)",
                          fn: function(row) {
                            return [
                              _c("b-badge", { attrs: { variant: "light" } }, [
                                _vm._v(_vm._s(row.item.departamento_atual))
                              ])
                            ]
                          }
                        },
                        {
                          key: "cell(tituloTipo)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.tipoOcorrencia(row.item.tipo)) +
                                  "\n          "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(actions)",
                          fn: function(row) {
                            return [
                              _vm.perfil != "distribuidor"
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "primary",
                                        title: "Visualizar"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verOcorrenciaAdm(
                                            row.item.id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-comments"
                                      })
                                    ]
                                  )
                                : _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "primary",
                                        title: "Visualizar"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verOcorrencia(row.item.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-comments"
                                      })
                                    ]
                                  )
                            ]
                          }
                        },
                        _vm.perfil != "distribuidor"
                          ? {
                              key: "cell(historico)",
                              fn: function(row) {
                                return [
                                  row.item.historicoInvertido.length > 0
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "light",
                                            title: "Historico"
                                          },
                                          on: { click: row.toggleDetails }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-history"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          : null,
                        {
                          key: "row-details",
                          fn: function(row) {
                            return [
                              row.item.historicoInvertido &&
                              row.item.historicoInvertido.length > 0
                                ? _c(
                                    "b-card",
                                    { attrs: { "bg-variant": "secondary" } },
                                    [
                                      row.item.historicoInvertido &&
                                      row.item.historicoInvertido.length > 0
                                        ? _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "justify-content-md-center"
                                            },
                                            _vm._l(
                                              row.item.historicoInvertido,
                                              function(h, index) {
                                                return _c(
                                                  "div",
                                                  { key: index },
                                                  [
                                                    _c(
                                                      "b-badge",
                                                      {
                                                        attrs: {
                                                          variant: "primary"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(h.departamento)
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    index <
                                                    row.item.historicoInvertido
                                                      .length -
                                                      1
                                                      ? _c("i", {
                                                          staticClass:
                                                            "fas fa-arrow-right ml-3 mr-3"
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-mensagens-bar", {
        attrs: { sidebar: _vm.sidebar, ocorrencia: _vm.ocorrenciaSelecionada },
        on: {
          "update:sidebar": _vm.updateSidebar,
          loadOcorrencias: _vm.loadOcorrencias
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c1a2f62", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c1a2f62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4c1a2f62","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/ocorrencia/List.vue
// module chunks = 2